module.exports = __webpack_public_path__ + "img/PP.bedbf916.png";